import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import LoadingPlaceholder from "./LoadingPlaceholder"

export function SerpBody({ loading, foundProducts }) {
    if (loading) return <LoadingPlaceholder />
    return (
        foundProducts ? 
        <>
            <Toolbar />
            <SelectedFilters />
            <Products />
            <BottomToolbar />
        </> : <NoResults />
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <LoadingPlaceholder /> : <NoResults />
    return (
        <>
            <Toolbar />
            <SelectedFilters />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBody)
